"use client";

import styles from "./AuthorizeSuccess.module.scss";
import { Flex } from "@vetty/ui";

/**
 * Authorize Success Component
 *
 * Shows success message after desktop app authorization
 */
export const AuthorizeSuccess = () => {
  return (
    <Flex
      direction={"column"}
      align={"center"}
      gap={12}
      className={styles["comp"]}
    >
      <h1 className={styles["comp__heading"]}>
        Authorization <span>successful!</span>
      </h1>

      <div className={styles["comp__description"]}>
        You can now close this window and return to the desktop app.
      </div>
    </Flex>
  );
};
